import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=7279c68d&"
import script from "./ResetPassword.vue?vue&type=script&lang=js&"
export * from "./ResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/.jenkins/workspace/crm-ui/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7279c68d')) {
      api.createRecord('7279c68d', component.options)
    } else {
      api.reload('7279c68d', component.options)
    }
    module.hot.accept("./ResetPassword.vue?vue&type=template&id=7279c68d&", function () {
      api.rerender('7279c68d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/profile/components/ResetPassword.vue"
export default component.exports